// Turn a bare handle or display name into a real URL so <a href="…"> works.
// Users often type "@handle" or "handle" or "Some Display Name" into admin —
// this converts those to proper links per platform.

const BASE = {
  twitter:   'https://x.com/',
  facebook:  'https://facebook.com/',
  instagram: 'https://instagram.com/',
  youtube:   'https://youtube.com/@',
  linkedin:  'https://linkedin.com/in/',
};

export function normalizeSocial(platform, raw) {
  if (raw == null) return '';
  const v = String(raw).trim();
  if (!v) return '';
  if (v.startsWith('http://') || v.startsWith('https://')) return v;
  if (platform === 'email') {
    if (v.startsWith('mailto:')) return v;
    return v.includes('@') ? `mailto:${v}` : v;
  }
  if (platform === 'website') {
    if (v.includes('.') && !v.includes(' ')) return `https://${v}`;
    return v;
  }
  const base = BASE[platform];
  if (!base) return v;
  let handle = v.replace(/^@/, '');
  if (handle.includes(' ')) handle = handle.replace(/\s+/g, '.').toLowerCase();
  return `${base}${handle}`;
}
